export const typography = {
  fontFamily: ["Coda", "Poppins"].join(","),
};

// !!!!!!!!! add these variables into config.scss also !!!!!!!!!
export const themeColors = {
  primary: "#00F0FF",
  primaryDim: "#00f0ff80",
  primaryLight: "#B7FBFF",
  primaryDark: "#0e505e",
  white: "#FFFFFF",
  grayLight: "#b3b3b3",
  graySecondary: "#dddddd",
  danger: "#f44336",
  success: "#00ff0d",
};

export const palette = {
  primary: {
    main: themeColors.primary,
  },
  primaryDim: {
    main: themeColors.primaryDim,
  },
  primaryLight: {
    main: themeColors.primaryLight,
  },
  primaryDark: {
    main: themeColors.primaryDark,
  },
  white: {
    main: themeColors.white,
  },
  grayLight: {
    main: themeColors.grayLight,
  },
  graySecondary: {
    main: themeColors.graySecondary,
  },
  danger: {
    main: themeColors.danger,
  },
  success: {
    main: themeColors.success,
  },
};
